import React, { useState } from 'react';
import { Typography, Checkbox, FormControlLabel, Button, Grid, CircularProgress, Box, TextareaAutosize } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';

function OptOutScreen() {
	const location = useLocation();
  	const userData = location.state && location.state.userData;
	const [showError, setShowError] = useState(false);
	const [apiResponse, setApiResponse] = useState('');
	const [loading, setLoading] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const [optOutChecked, setOptOutChecked] = useState(false);
	const [optOutReason, setOptOutReason] = useState('');
	const apiUrl = process.env.REACT_APP_API_URL_PROD || '';
	
	const useStyles = makeStyles((theme) => ({
			formBox: {
					padding: theme.spacing(4),
					boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
					backgroundColor: '#f4f7fd',
					marginTop: theme.spacing(2), 
			},
			legalText: {
					marginBottom: theme.spacing(2),
			},
			submitButton: {
					marginTop: theme.spacing(2),
			},
			errorText: {
					color: 'red',
					marginTop: theme.spacing(1),
			},
			thankYouText: {
					textAlign: 'center',
					marginTop: '24px !important',
					wordWrap: "break-word",
			},
			optOutForm: {
				marginTop: theme.spacing(4),
			},
			optOutReason: {
				width: '100%',
				minHeight: '100px',
				marginTop: theme.spacing(2),
				padding: theme.spacing(1),
				border: '1px solid #ccc',
				borderRadius: '4px',
				resize: 'vertical',
			},
	}));
	const classes = useStyles();

	const handleOptOutCheckboxChange = (event) => {
		setOptOutChecked(event.target.checked);
	};
	
	const handleOptOutReasonChange = (event) => {
		setOptOutReason(event.target.value);
	};
	
	const handleOptOutSubmit = async (event) => {
	event.preventDefault();
	setApiResponse('');

	if (!optOutChecked) {
		setShowError(true);
	} else {
		setShowError(false);
		setLoading(true);
		
		try {
			fetch(apiUrl + '/api/save_optout', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Access-Control-Allow-Origin': '*',
					},
					body: JSON.stringify({ optOutReason: optOutReason, userData: userData, optOutDate: new Date().toLocaleString() + "" }, null, 2),
			})
				.then((response) => response.json())
				.then((data) => {
					const newData = decodeURI(data['response']);
					setApiResponse(newData);
					setLoading(false);
					setSubmitted(true);
				})
				.catch((error) => {
					console.error('Error in save_optout fetch:', error);
					setLoading(false);
				});
			} catch (err) {
				console.error("Error calling /api/save_optout",err);
			}
		}//end if/else
	}; //end handleOptOutSubmit
    
	return (
		<Grid container spacing={2} rowSpacing={2}>
			<Grid item xs={2}/>
			<Grid item xs={6} alignItems="center">
				<Box className={classes.formBox}>
				<Typography variant="h4" component="h4" align="center">SideKick for PSA</Typography>
				{submitted ? (   
					<Typography variant="h5" className={classes.thankYouText}>
						Thank you! <br/>SideKick for PSA has been removed.
					</Typography>  	
				) : (
					<form className={classes.optOutForm} onSubmit={handleOptOutSubmit}>
						<Typography variant="h5" className={classes.thankYouText}>
							You are currently using a SideKick for PSA hosted pod in your Service Tickets screen.
						</Typography>
						<Typography variant="body1" className={classes.legalText}>
								If you decide you no longer want to use SideKick for PSA, please opt out below and we will remove it.
						</Typography>
						<br />
						<FormControlLabel control={
								<Checkbox checked={optOutChecked} onChange={handleOptOutCheckboxChange} color="primary" />
							}
							label="Yes, I would like to opt out of SideKick for PSA and want it removed"
						/>
						<TextareaAutosize
							className={classes.optOutReason}
							placeholder="Reason for opting out"
							value={optOutReason}
							onChange={handleOptOutReasonChange}
						/>
						{showError && (
							<Typography variant="body2" className={classes.errorText}>
									Please provide a reason and opt-out confirmation.
							</Typography>
						)}
						<Button
							type="submit"
							variant="contained"
							color="primary"
							className={classes.submitButton}
							disabled={!optOutChecked || optOutReason.trim() === ''}
						>Submit
						</Button>
						<Grid item xs={8}>
							{!apiResponse && loading ? (
								<div style={{ textAlign: 'center' }}>
									<CircularProgress />
								</div>
								) : (
								<div />
							)}
						</Grid>  
					</form>              
				)}
				</Box>      
			</Grid>
			<Grid item xs={2}/>
		</Grid>
	);
}    
export default OptOutScreen;